module.exports = __webpack_public_path__ + "static/bg-fleet-advantage-16da40c048e6128959bff2d30e100fe3.webp";